export default "__VITE_ASSET__CwmlaU67__"